import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "calculator",
    component: () => import("../views/Calculator.vue"),
  },
  // {
  //   path: "/initiate",
  //   name: "initiate",
  //   component: () => import("../views/Initiate.vue")
  // }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
